import { Navigate, Route, Routes } from "react-router-dom";
import { AuthGuard } from "./components/AuthGuard";
import { ConflictDialog } from "./components/ConflictDialog";
import { NavBar } from "./components/NavBar";
import AuthCallback from "./pages/AuthCallback";
import BudgetDashboard from "./pages/BudgetDashboard";
import ConsultantPlanner from "./pages/ConsultantPlanner";

function Protected({ children }: { children: React.ReactNode }) {
  return (
    <AuthGuard>
      <div className="flex h-full flex-col">
        <NavBar />
        <main className="flex-1 overflow-auto">{children}</main>
      </div>
    </AuthGuard>
  );
}

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route
          path="/planner"
          element={
            <Protected>
              <ConsultantPlanner />
            </Protected>
          }
        />
        <Route
          path="/budget"
          element={
            <Protected>
              <BudgetDashboard />
            </Protected>
          }
        />
        <Route path="*" element={<Navigate to="/planner" replace />} />
      </Routes>
      <ConflictDialog />
    </>
  );
}
